<template>
  <div class="">
    <popupapercu
      v-if="activeApercu && selectedItem.length > 0"
      :want-to-make-offer="activeApercu"
      :donnes="selectedItem"
      @oga="retourApercu"
    />
    <div class="md:flex">
      <div
        class="md:w-1/2 w-full bloc1 text-center md:p-16 p-10"
        data-aos="fade-right"
        data-aos-duration="2000"
      >
        <div class="titre">
          ARSEN IARD
        </div>
        <div class="flex justify-center items-center md:mt-12 mt-6 pt-2 md:mb-16 mb-8">
          <svg-icon
            name="ic_car"
            class="md:h-12 h-6 cursor-pointer mr-10"
            original
          />
          <svg-icon
            name="ic_bike"
            class="md:h-12 h-6 cursor-pointer mr-10"
            original
          />
          <svg-icon
            name="ic_plane"
            class="md:h-12 h-6 cursor-pointer mr-10"
            original
          />
          <svg-icon
            name="ic_home"
            class="md:h-12 h-5 cursor-pointer"
            original
          />
        </div>

        <div class="flex justify-center mb-6">
          <div
            class="nom text-white rounded-full cursor-pointer"
            @click="openPopup('iard')"
          >
            Aperçu
          </div>
        </div>
      </div>

      <div
        class="md:w-1/2 w-full bloc2 text-center md:p-16 p-10"
        data-aos="fade-left"
        data-aos-duration="2000"
      >
        <div class="titre">
          ARSEN SANTÉ
        </div>
        <div class="flex justify-center md:mt-12 mt-6 md:mb-16 mb-8">
          <svg-icon
            name="ic_health"
            class="md:h-16 h-5 cursor-pointer"
            original
          />
        </div>
        <div class="flex justify-center mb-6">
          <div
            class="nom text-white rounded-full cursor-pointer"
            @click="openPopup('sante')"
          >
            Aperçu
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popupapercu from '@/components/popup/popupApercu'
import arsen from '@/assets/images/webp/Frame1.webp'
import arsen1 from '@/assets/images/webp/Frame2.webp'
import sant from '@/assets/images/webp/iard1.webp'
import sant1 from '@/assets/images/webp/iard2.webp'
import a1 from '@/assets/images/webp/a1.webp'
import a2 from '@/assets/images/webp/a2.webp'
import a3 from '@/assets/images/webp/a3.webp'
import a4 from '@/assets/images/webp/a4.webp'

export default {
  name: 'Index',
  components: {
    popupapercu
  },
  props: {
  },
  data () {
    return {
      activeApercu: false,
      sante: [arsen, arsen1, sant, sant1],
      iard: [a1, a2, a3, a4],
      selectedItem: null
    }
  },
  created () {
  },
  methods: {
    retourApercu (answer) {
      this.activeApercu = answer
    },
    openPopup (index) {
      if (index === 'iard') {
        this.selectedItem = this.iard
      }
      if (index === 'sante') {
        this.selectedItem = this.sante
      }
      this.activeApercu = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
 }

  .titre{
    font-weight: 800;
    font-size: 40px;
    line-height: 150%;
    /* identical to box height, or 60px */
    letter-spacing: 0.01em;
    color: $white;
  }
  .bloc1{
    background-color: $devs_color;
    .nom{
      font-weight: normal;
      font-size: 24px;
      line-height: 160%;
      background-color: #5700C1;
      width: 25%;
    }
  }

  .bloc2{
    background-color: $dev-green;
    .nom{
      font-weight: normal;
      font-size: 24px;
      line-height: 160%;
      background-color: #1AA154;
      width: 25%;
    }
  }
  .svg-fill{
    fill: transparent;
  }

  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .titre{
      font-size: 22px;
    }
    .bloc1{
      width: 100%;
      .nom{
        font-size: 13.8141px;
      }
    }
    .bloc2{
      width: 100%;
      font-size: 18px;
      .nom{
        font-size: 13.8141px;
      }
    }

    .title3{
      font-size: 18px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .bloc1, .bloc2{
      .nom{
        font-size: 18px;
      }
    }
    .titre{
      font-size: 32px;
    }
  }
</style>
